function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u56FE\\u5C42_2",
  "data-name": "\\u56FE\\u5C42 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Discord_Logos",
  "data-name": "Discord Logos"
}, /*#__PURE__*/React.createElement("g", {
  id: "Discord_Logo_-_Large_-_White",
  "data-name": "Discord Logo - Large - White"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.94,2.09A27.46,27.46,0,0,0,21.14,0a17.06,17.06,0,0,0-.87,1.77,25.21,25.21,0,0,0-7.56,0A19.34,19.34,0,0,0,11.84,0,27.56,27.56,0,0,0,5,2.1,27.49,27.49,0,0,0,.14,20.81h0A27.53,27.53,0,0,0,8.49,25a20.29,20.29,0,0,0,1.78-2.88,18.59,18.59,0,0,1-2.81-1.35c.24-.17.47-.34.69-.52a19.58,19.58,0,0,0,16.69,0,5.67,5.67,0,0,0,.69.52,18.7,18.7,0,0,1-2.82,1.35A20.29,20.29,0,0,0,24.49,25a27.36,27.36,0,0,0,8.36-4.19h0A27.48,27.48,0,0,0,27.94,2.09ZM11,17a3.15,3.15,0,0,1-3-3.29,3.13,3.13,0,0,1,3-3.3,3.11,3.11,0,0,1,3,3.3A3.15,3.15,0,0,1,11,17Zm11,0a3.15,3.15,0,0,1-3-3.29,3.13,3.13,0,0,1,3-3.3,3.11,3.11,0,0,1,3,3.3A3.15,3.15,0,0,1,22,17Z",
  fill: "#fff"
}))));

function SvgIconClydeWhiteCmyk25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.99 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClydeWhiteCmyk25);
export default __webpack_public_path__ + "static/media/icon_clyde_white_CMYK_25.90cf1b01.svg";
export { ForwardRef as ReactComponent };